import React from "react";

const SessionExpiryModal = ({ secondsLeft, isRefreshing, onExtend, onLogout, formatCountdown }) => {
    return (
        <div className="fixed inset-0 z-[2000] bg-black/50 flex items-center justify-center px-4">
            <div className="bg-white dark:bg-acs-dark-surface rounded-2xl shadow-xl w-full max-w-sm p-6 space-y-4">
                <div className="flex items-start gap-3">
                    <div className="flex-shrink-0 w-10 h-10 rounded-full bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center">
                        <svg className="w-5 h-5 text-amber-600 dark:text-amber-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
                        </svg>
                    </div>
                    <div>
                        <h2 className="text-base font-semibold text-gray-900 dark:text-acs-dark-text">
                            Session Expiring Soon
                        </h2>
                        <p className="text-sm text-gray-500 dark:text-acs-dark-subtext mt-0.5">
                            Your session expires in{" "}
                            <span className="font-mono font-semibold text-amber-600 dark:text-amber-400">
                                {formatCountdown(secondsLeft)}
                            </span>
                        </p>
                    </div>
                </div>

                <p className="text-sm text-gray-600 dark:text-acs-dark-subtext">
                    Would you like to extend your session or log out?
                </p>

                <div className="flex gap-3 pt-1">
                    <button
                        onClick={onExtend}
                        disabled={isRefreshing}
                        className="flex-1 px-4 py-2 bg-[#223688] dark:bg-[#31C4AB] text-white dark:text-[#1A1C23] rounded-lg text-sm font-medium hover:bg-[#1c2c6d] dark:hover:bg-[#27b099] disabled:opacity-60 transition-none"
                    >
                        {isRefreshing ? "Extending..." : "Extend Session"}
                    </button>
                    <button
                        onClick={onLogout}
                        className="flex-1 px-4 py-2 border border-gray-300 dark:border-acs-dark-border text-gray-700 dark:text-acs-dark-text rounded-lg text-sm hover:bg-gray-100 dark:hover:bg-acs-dark-hover transition-none"
                    >
                        Log Out
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SessionExpiryModal;
